module.exports = __webpack_public_path__ + "img/take_away_green.623aa33e.svg";